var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 100,
    viewBox: "0 0 77 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_207_7368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8629 0H0V100H76.8629V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_207_7368)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_207_7368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8629 0H0V100H76.8629V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_207_7368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49638 26.6371C4.24357 60.934 5.11076 78.5397 38.4291 96.3088C71.7583 78.5234 72.6146 60.9231 73.3618 26.6262C51.066 23.3108 41.7506 11.5954 38.4018 5.69964C34.9549 11.6227 25.4595 23.4687 3.49638 26.6371ZM38.4291 99.9998C38.1509 99.9998 37.8728 99.9345 37.6219 99.7984C1.20026 80.6684 0.774845 60.9558 -0.00507339 25.1618C-0.0214353 24.2744 0.6385 23.5123 1.51659 23.4034C29.5882 19.9737 36.5147 1.89977 36.7984 1.13217C37.0492 0.440787 37.731 -0.00561523 38.4509 -0.00561523C39.1872 0.00527267 39.8362 0.473455 40.0707 1.17028C40.3271 1.92155 46.7682 19.7505 75.3471 23.4034C76.2251 23.5123 76.8796 24.2744 76.8633 25.1563C76.0888 60.934 75.6688 80.6466 39.2363 99.793C38.9799 99.929 38.7072 99.9944 38.4291 99.9944",
    fill: "#DE3450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4292 91.7306C38.1402 91.7306 37.8457 91.6598 37.5839 91.5128C9.61043 75.954 8.01787 60.9396 7.29795 31.1339C7.27613 30.2956 7.86517 29.5661 8.68326 29.3973C23.6599 26.3596 32.3753 19.1082 37.0494 13.5554C37.6657 12.8205 38.7619 12.7279 39.4928 13.3431C40.2236 13.9583 40.3218 15.0525 39.7055 15.7765C34.8242 21.5744 25.8906 29.087 10.7939 32.484C11.5139 60.4224 13.2864 73.771 38.4238 88.0178C63.9975 73.5206 65.3937 59.9597 66.0918 31.036C66.1136 30.0778 66.9263 29.3102 67.8698 29.3483C68.8242 29.3701 69.5823 30.1649 69.5605 31.1176C68.8406 60.9287 67.2535 75.9486 39.2691 91.5128C39.0074 91.6598 38.7183 91.7306 38.4238 91.7306",
    fill: "#DE3450"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon_6.77e2b649f5a02f3c88c9160dfe8336f4.svg";
export { ForwardRef as ReactComponent };